import HTTP from "@/service/HTTP";

const bookService = new HTTP("/v1/books");
const bookPackageService = new HTTP("/v1/packages");
const chapterService = new HTTP("/v1/chapters");
const competenceModuleService = new HTTP("/v1/competenceModules");
const schoolSubjectService = new HTTP("/v1/schoolSubjects");
const schoolTypeService = new HTTP("/v1/schoolTypes");
const skillService = new HTTP("/v1/skills");
const taskService = new HTTP("/v1/tasks/pagination");
const taskTypeService = new HTTP("/v1/taskTypes");
const topicService = new HTTP("/v1/topics");
const filterService = new HTTP("/v1/filter");
const contentTypeService = new HTTP("/v1/contentTypes");
const dashboardService = new HTTP("/v1/editor/dashboard");

export default {
  BOOK: bookService,
  CHAPTER: chapterService,
  BOOK_PACKAGE: bookPackageService,
  COMPETENCE_MODULE: competenceModuleService,
  SCHOOL_SUBJECT: schoolSubjectService,
  SCHOOL_TYPE: schoolTypeService,
  SKILL: skillService,
  TASK: taskService,
  TASK_TYPE: taskTypeService,
  TOPIC: topicService,
  FILTER: filterService,
  CONTENT_TYPE: contentTypeService,
  DASHBOARD: dashboardService
};
